import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  validateBatchSize(event) {
    const input = event.target
    const max = parseInt(input.dataset.maxBatchSize, 10)
    if (input.files.length > max) {
      alert(`You can only upload ${max} photos at a time.`)
      input.value = ""
    }
  }
}
